export default function SubscriptionsDisclaimer() {
    return (
        <div className="flex flex-col items-center justify-center text-white font-montserrat">
            <h3 className="text-lg">*Tarif entrée basique 25€</h3>
            <p className="text-lg">Et accès uniquement aux expositions permanentes</p>
        </div>
    )
}
